import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick"];
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import MediaServicesActualSizeIcon from '@atlaskit/icon/core/migration/grow-diagonal--media-services-actual-size';
import PanelRightIcon from '@atlaskit/icon/core/panel-right';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { ActionName } from '../../../../../constants';
import { messages } from '../../../../../messages';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import useInvokeClientAction from '../../../../../state/hooks/use-invoke-client-action';
import Action from '../action';
var PreviewAction = function PreviewAction(_ref) {
  var _context$actions;
  var onClickCallback = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var context = useFlexibleUiContext();
  var invoke = useInvokeClientAction({});
  var data = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[ActionName.PreviewAction];
  var hasPreviewPanel = data === null || data === void 0 ? void 0 : data.hasPreviewPanel;
  var onClick = useCallback(function () {
    if (data !== null && data !== void 0 && data.invokeAction) {
      invoke(data.invokeAction);
      onClickCallback === null || onClickCallback === void 0 || onClickCallback();
    }
  }, [data, invoke, onClickCallback]);
  var isStackItem = props.as === 'stack-item';
  var tooltipMessage = isStackItem ? messages.preview_description : messages.preview_improved;
  var actionIcon = useCallback(function () {
    // Only use panel icon if experiment is enabled and hasPreviewPanel is true
    if (expValEquals('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) {
      return /*#__PURE__*/React.createElement(PanelRightIcon, {
        color: "currentColor",
        spacing: "spacious",
        label: "Open preview panel"
      });
    }
    return /*#__PURE__*/React.createElement(MediaServicesActualSizeIcon, {
      color: "currentColor",
      spacing: "spacious",
      label: "Open preview"
    });
  }, [hasPreviewPanel]);
  var actionLabel = useCallback(function () {
    // Only use panel message if experiment is enabled and hasPreviewPanel is true
    if (expValEquals('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) {
      return /*#__PURE__*/React.createElement(FormattedMessage, messages.preview_panel);
    }
    // Fall back to modal message if experiment is enabled, otherwise use original preview message
    if (expValEquals('platform_hover_card_preview_panel', 'cohort', 'test')) {
      return /*#__PURE__*/React.createElement(FormattedMessage, messages.preview_modal);
    }
    return /*#__PURE__*/React.createElement(FormattedMessage, messages.preview_improved);
  }, [hasPreviewPanel]);
  return data ? /*#__PURE__*/React.createElement(Action, _extends({
    content: actionLabel(),
    icon: actionIcon(),
    onClick: onClick,
    testId: "smart-action-preview-action",
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, tooltipMessage),
    hideTooltipOnMouseDown: true
  }, data, props)) : null;
};
export default PreviewAction;